angular.module('bmsApp.settings').factory('ContactDetailTypeSvc',
		function ($http, $log, $window, $q, CRUDSvc, CONACT_DETAIL_TYPE_API, CONTACT_DETAIL_GROUP) {

			return {
				index: function (params) {
					var deferred = $q.defer();
					$http.get(CONACT_DETAIL_TYPE_API.INDEX, {params: params})
							.then(function (response) {
								if (response.data.success) {

									var allTypes = response.data.types;
							
									var email = [], phone = [], web = [];

									_.each(allTypes, function (type) {
										switch (type.group) {
											case CONTACT_DETAIL_GROUP.PHONE:
												phone.push({id: type.id, value: type.contact_detail_type});
												break;
											case CONTACT_DETAIL_GROUP.EMAIL:
												email.push({id: type.id, value: type.contact_detail_type});
												break;
											case CONTACT_DETAIL_GROUP.WEB:
												web.push({id: type.id, value: type.contact_detail_type});
												break;
										}
									})

									var types = {
											emailTypes: email,
										phoneTypes: phone,
										webTypes: web,
									}
									
									deferred.resolve(types);
								}
								else {
									deferred.reject(response.data.message);
								}
							}, function (error) {
								deferred.reject("A generic API error occured: " + error.data.error.message);
							});

					return deferred.promise;
				},
				indexRaw: function(params) {
					return $http.get(CONACT_DETAIL_TYPE_API.INDEX, {params: params});
				},
				options: function () {
					return CRUDSvc.get(CONACT_DETAIL_TYPE_API.OPTIONS);
				}
			}

		}).constant('CONACT_DETAIL_TYPE_API', {
	INDEX: 'api/contactDetailTypes/index',
	OPTIONS: 'api/contactDetailTypes/options'
}).constant('CONTACT_DETAIL_GROUP', {
	PHONE: 'phone',
	EMAIL: 'email',
	WEB: 'web',
});




